export default __webpack_public_path__ + "static/media/Pic2.603fb45a.png";